<article class="current-subscription-card"
  [class.current-subscription-card--expired]="status === subscriptionStatusEnum.EXPIRED"
  [class.current-subscription-card--expiring]="status === subscriptionStatusEnum.EXPIRING">
  <img class="current-subscription-card__illustration" src="assets/images/profile/subscription-crown.svg" alt=""
    aria-hidden="true">
  <div class="current-subscription-card__content">
    <div class="current-subscription-card__heading align-items-center">
      <div class="current-subscription-card__identity">
        <p class="current-subscription-card__label">{{ 'profile.currentPlan' | translate }}</p>
        <h3>{{ subscription.name }}</h3>
      </div>
      <button type="button" class="current-subscription-card__renew" *ngIf="subscription.canRenew"
        (click)="renew.emit()">
        {{ 'subscription.renewPlan' | translate }}
      </button>
      @if (!subscription.isPlanAvailable) {
      <p class="current-subscription-card__not-available">{{ 'subscription.planNoLongerAvailable' | translate }}</p>
      }
      <div class="current-subscription-card__expiry" *ngIf="subscription.hasExpirationDate">
        <div class="current-subscription-card__date">
          <span>{{ expiryLabel | translate }}:</span>
          <time [attr.datetime]="subscription.expirationDate">
            {{ subscription.expirationDate | date:'d MMM yyyy' }}
          </time>
        </div>
        <span class="current-subscription-card__status" role="status" *ngIf="status !== subscriptionStatusEnum.ACTIVE">
          {{ ('subscription.' + status) | translate }}
        </span>
      </div>
    </div>
    <div class="current-subscription-card__features">
      <p>{{ 'subscription.includes' | translate }}</p>
      <ul>
        <li *ngFor="let feature of subscription.benefits"><img src="assets/images/icons/subscription-check-light.svg"
            alt="" aria-hidden="true"><span>{{ feature }}</span></li>
      </ul>
    </div>
  </div>
</article>
